"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var proxiedFilter = function (arr, proxy, args) {
    var retPlain = [];
    var retProxy = [];
    var containsProxies = false;
    for (var i = 0, len = arr.length; i < len; i++) {
        var cb = args[0];
        if (!cb(proxy[i], i))
            continue;
        var item = proxy[i];
        retProxy.push(item);
        if (item && item._isProxy) {
            retPlain.push(item.valueOf());
            containsProxies = true;
        }
    }
    if (containsProxies) {
        // Mark as `_isProxy` to ensure contained proxies can not contaminate
        // the plain value if assigned back to the store
        retProxy._isProxy = true;
        retProxy.valueOf = function () { return retPlain; };
    }
    return retProxy;
};
exports.default = proxiedFilter;
//# sourceMappingURL=proxiedFilter.js.map